

import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { separadorMillares } from "../../../hooks/useMillares";
import { MensajeAlertaDanger } from "../../components";
import { useBuscadorTodoStore } from "../../../stores/ui/buscadorTodo.store";
import { LayoutTabla } from "../../layouts";
import { fechaConHora } from "../../../helpers/prepararFecha";


const paginado = Number(process.env.REACT_APP_PAGINADO);




export const TablaCajaVentas = ({ data, chagePage=() => {}, page=0, totales }) => {


    const { totalVentaCaja } = useBuscadorTodoStore();

    return (
        <>
        {(data?.length > 0)
        ?   <>
            {(totales) &&
            <LayoutTabla mb={2}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width:'25%' }}>N° Abonos</TableCell>
                        <TableCell sx={{ width:'25%' }}>Total Venta</TableCell>
                        <TableCell sx={{ width:'25%' }}>Total Abonos</TableCell>
                        <TableCell sx={{ width:'25%' }}>Saldo Total</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow >
                        <TableCell>{`${ separadorMillares(totales.numeroAbonos)}`}</TableCell>
                        <TableCell>{`$${ separadorMillares(totales.totalVentas)}`}</TableCell>
                        <TableCell>{ `$${ separadorMillares(totales.totalAbonos)}` }</TableCell>
                        <TableCell>{`$${ separadorMillares(totales.saldoTotal)}`}</TableCell>
                    </TableRow>
                </TableBody>
            </LayoutTabla>
            }

            <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalVentaCaja / +paginado)} disabled={Math.ceil(totalVentaCaja / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'15%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'13%'}}>O.P.</TableCell>
                        <TableCell sx={{width:'15%'}}>Medio</TableCell>
                        <TableCell sx={{width:'14%'}}>Total</TableCell>
                        <TableCell sx={{width:'14%'}}>Abono</TableCell>
                        <TableCell sx={{width:'14%'}}>Saldo</TableCell>
                        <TableCell sx={{width:'17%'}}>User</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                {data.map((a) => (
                    <TableRow  key={ a.id}>
                        <TableCell>{ fechaConHora(a?.createdAt) }</TableCell>
                        <TableCell>{ a.op.op }</TableCell>
                        <TableCell>{ a.medio }</TableCell>
                        <TableCell>{ `$${ separadorMillares(a.op.totalOrden)}` }</TableCell>
                        <TableCell>{ `$${ separadorMillares(a.abono)}` }</TableCell>
                        <TableCell>{ `$${ separadorMillares((a.deudaFinal)) || 0}` }</TableCell>
                        <TableCell>
                            { (a.user) 
                            ? <Typography sx={{color:"error", fontWeight:'bold', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', fontSize:13 }}>{ a.user.nombre }</Typography> 
                            : <Typography sx={{ color:"red", fontWeight:'bold' }}>No-Dato</Typography> 
                            }
                        </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </LayoutTabla>
            </>   

        :   <MensajeAlertaDanger titulo='No hay ops disponibles' />
        }
        </>
    )
}
